import {useState} from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import DeleteQuestionModal from  "../../modals/DeleteQuestionModal.jsx";

 let newindex = '';
 
function WhQuestionsRenderer({
  questions,
  handleShortWhQuestionChange,
  handleShortWhAnswerChange,
  handleShortWhQuestionsEdit,
  handleShortWhAnswersEdit,
  handleShortWhQuestionDelete,
}) {
  
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  let totalQuestion = 1;
  
  const handleDeleteClick = (index) => {  
    setShowDeleteModal(true);
    newindex = index + 1;
  };

    // Handler for confirming delete
  const handleConfirmDelete = () => {
    handleShortWhQuestionDelete(newindex - 1);
  };
  
  return (
    <>
      {questions.map((whQuestion, index) => (
        <div
          key={index}
          className="mb-4 border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
        >
          <div className="flex place-content-between">
            <div className="flex ">
              <span>{totalQuestion++}.&nbsp; </span>{" "}
              {whQuestion.editing ? (
                <div
                  contentEditable="true"
                  id={`question-${index}`}
                  className="wh-question-editable "
                  onBlur={(e) => {
                    handleShortWhQuestionChange(index, e.target.textContent);
                    handleShortWhQuestionsEdit(index);
                  }}
                  dangerouslySetInnerHTML={{ __html: whQuestion.Question }}
                />
              ) : (
                <span
                  onClick={() => handleShortWhQuestionsEdit(index)}
                  className="cursor-pointer"
                  dangerouslySetInnerHTML={{ __html: whQuestion.Question }}
                />
              )}
            </div>
            <div className="flex  edit-delete-icons">
              <Tooltip
                title="Edit"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={() => handleShortWhQuestionsEdit(index)}
                  className="text-indigo-500 mr-2"
                >
                  <i className="fa-solid fa-pen-to-square"></i>{" "}
                </button>
              </Tooltip>

              <Tooltip
                title="Delete"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={()=>handleDeleteClick(index)}
                  className="text-red-500"
                >
                  <i className="fa-solid fa-trash"></i>{" "}
                </button>
              </Tooltip>
            </div>
          </div>
          <p>
            <p className="font-semibold">Answer:</p>{" "}
            {whQuestion.editingAnswer ? (
              <div
                contentEditable="true"
                className="answer-editable"
                onBlur={(e) => {
                  handleShortWhAnswerChange(index, e.target.textContent);
                  handleShortWhAnswersEdit(index);
                }}
                dangerouslySetInnerHTML={{ __html: whQuestion.Answer }}
              />
            ) : (
              <span
                onClick={() => handleShortWhAnswersEdit(index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{ __html: whQuestion.Answer }}
              />
            )}
          </p>
        </div>
      ))
      }
      <DeleteQuestionModal
                open={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirmDelete={handleConfirmDelete}
                questionNumber={newindex}
              />
    </>
  );
}

export default WhQuestionsRenderer;
